export default __webpack_public_path__ + "static/media/img-rotate-anticlock.240c35cf.svg";